export const handleRoleFields = (
  handleOnChange,
  { roleName, description },
  modalType,
  isRoleInvalid
) => [
  {
    id: 'name_id',
    label: 'Administration:RolesManagement.RoleForm.Name',
    placeholder: 'Administration:RolesManagement.RoleForm.Name',
    handleChange: (e) =>
      handleOnChange({
        roleName: e.target.value
      }),
    isDisabled: modalType === 'UpdateRole',
    isInvalid: isRoleInvalid,
    invalidText:
      isRoleInvalid && 'Administration:RolesManagement.RequiredValue',
    name: 'roleName',
    value: roleName,
    type: 'text'
  },
  {
    id: 'desc_id',
    label: 'Administration:RolesManagement.RoleForm.Desc',
    placeholder: 'Administration:RolesManagement.RoleForm.Desc',
    handleChange: (e) =>
      handleOnChange({
        description: e.target.value
      }),
    name: 'description',
    value: description,
    type: 'text'
  }
]
